import changePasswordIcon from "@/assets/icons/changePassword.svg?react";
import logoutIcon from "@/assets/icons/logout2.svg?react";
import { LocalStorage } from "@/common/storage.ts";
import { ConfirmButtonRef } from "@/component/common/button/ConfirmButton.tsx";
import ChangePasswordModal, {
    ChangePasswordModalRef,
} from "@/component/common/modals/ChangePasswordModal.tsx";
import Icon from "@ant-design/icons";
import { Avatar, Dropdown, MenuProps } from "antd";
import * as jdenticon from "jdenticon";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const UserHeaderButton = ({
  logoutModalRef,
}: {
  logoutModalRef?: ConfirmButtonRef;
}) => {
  const { t } = useTranslation();
  const userInfo: LocalUserInfo = LocalStorage.getUserInfo();

  const changePasswordModelRef = useRef<ChangePasswordModalRef>();

  const items: MenuProps["items"] = [
    {
      key: "1",
      icon: <Icon component={changePasswordIcon} style={{ fontSize: 18 }} />,
      label: t("button.changePassword"),
      onClick: () => changePasswordModelRef.current?.openModal(),
    },
    {
      key: "2",
      danger: true,
      icon: <Icon component={logoutIcon} style={{ fontSize: 18 }} />,
      label: t("button.logout"),
      onClick: () => logoutModalRef?.openModal(),
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} placement={"bottomRight"}>
        <div
          className={
            "relative w-fit px-3 rounded hover:cursor-pointer hover:bg-gray-50"
          }
        >
          {(() => {
            const defaultPath = "/avatarUserDefault.svg";
            const hasCustomAvatar =
              userInfo?.avatar && userInfo.avatar !== defaultPath;
            if (hasCustomAvatar) {
              return (
                <Avatar
                  src={userInfo!.avatar!}
                  style={{ verticalAlign: "middle" }}
                  size="large"
                />
              );
            }

            const seed = (userInfo?.email || userInfo?.username || "")
              .trim()
              .toLowerCase();
            if (seed) {
              const svg = jdenticon.toSvg(seed, 64);
              const dataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
              return (
                <Avatar
                  src={dataUrl}
                  style={{ verticalAlign: "middle" }}
                  size="large"
                />
              );
            }

            return (
              <Avatar
                src={defaultPath}
                style={{ verticalAlign: "middle" }}
                size="large"
              />
            );
          })()}
          <span className={"ml-2 text-[#22242C] text-size-2 font-bold"}>
            {userInfo?.username}
          </span>
        </div>
      </Dropdown>
      <ChangePasswordModal ref={changePasswordModelRef} />
    </>
  );
};

export default UserHeaderButton;
